import createElement from '../../logical-components/createElement';
import Checkbox from "../../components/atoms/Checkbox/Checkbox";
import '../scss/input.scss';
var buildField = function (inputConfig) {
    var name = inputConfig.name, label = inputConfig.label, labelInfo = inputConfig.labelInfo, id = inputConfig.id, error = inputConfig.error, defaultValue = inputConfig.defaultValue, placeholder = inputConfig.placeholder, onChange = inputConfig.onChange, type = inputConfig.type, onFocus = inputConfig.onFocus, outFocus = inputConfig.outFocus, onEnter = inputConfig.onEnter, _a = inputConfig.fieldType, fieldType = _a === void 0 ? 'input' : _a;
    var wrapperClass = '_msng-input-wrapper';
    if (error) {
        wrapperClass += ' ' + error;
    }
    var wrapper = createElement('div', [
        { type: 'class', value: wrapperClass },
    ]);
    var input = null;
    switch (fieldType) {
        case 'input':
            wrapper.innerHTML = "\n                <label for='field-".concat(id, "'> ").concat(label, " ").concat(labelInfo
                ? "<span class=\"_msnlq-info\">i<span class=\"_msnlq-info-panel\">".concat(labelInfo, "</span></span>")
                : '', "\n                <span class=\"_mnslq-error\">").concat(error !== null && error !== void 0 ? error : '', "</span>\n                </label>\n                <input autocomplete=\"off\" data-lpignore=\"true\" ").concat(type === 'date' ? 'type="date"' : '', " id='field-").concat(id, "' value='").concat(defaultValue || '', "' placeholder='").concat(placeholder, "' name=\"").concat(name, "\"/>\n            ");
            input = wrapper.querySelector('input');
            break;
        case 'textarea':
            wrapper.innerHTML = "\n                <label for='field-".concat(id, "'> ").concat(label, " <span class=\"_mnslq-error\">").concat(error, "</span></label>\n                <textarea autocomplete=\"off\" data-lpignore=\"true\" ").concat(type === 'date' ? 'type="date"' : '', " id='field-").concat(id, "' value='").concat(defaultValue || '', "' placeholder='").concat(placeholder, "' name=\"").concat(name, "\"></textarea>\n            ");
            input = wrapper.querySelector('textarea');
            break;
        case 'checkbox':
            input = Checkbox({
                name: name,
                label: label,
                error: error,
                id: "field-".concat(id)
            });
            wrapper.append(input);
            break;
        default:
            throw new ReferenceError("Not implemented input type: '".concat(fieldType, "'."));
    }
    // Apply event listener
    input.addEventListener('input', function (event) {
        if (onChange) {
            onChange(event);
        }
    });
    input.addEventListener('focus', function () {
        if (onFocus) {
            onFocus();
        }
    });
    input.addEventListener('blur', function () {
        if (outFocus) {
            outFocus();
        }
    });
    input.addEventListener('keypress', function (e) {
        var keyboardEvent = e;
        if ((keyboardEvent === null || keyboardEvent === void 0 ? void 0 : keyboardEvent.key) && keyboardEvent.key === 'Enter') {
            keyboardEvent.preventDefault();
            onEnter();
        }
    });
    return wrapper;
};
export default buildField;
